import React from "react";
import { defineMessages, useIntl } from "react-intl";
import Link from "theme/components/atoms/Typography/Link";
import FormActions from "theme/components/molecules/Form/FormActions";

const messages = defineMessages({
  seeCartAction: {
    id: "modules.Cart.MiniCart.MiniCartContent.seeCart",
    defaultMessage: "View my cart",
  },
  checkoutAction: {
    id: "modules.Cart.MiniCart.MiniCartContent.checkout",
    defaultMessage: "Proceed to checkout",
  },
  cartLink: {
    id: "modules.Cart.MiniCart.MiniCartContent.cartLink",
    defaultMessage: "See cart",
  },
});

const MiniCartActions = ({ cart }) => {
  const intl = useIntl();

  const isAmountToReachMinOrderKO =
    parseFloat(cart.minimum_order_amount) >
    parseFloat(cart.totals.totalInclTax.value.amount);
  return (
    <div className="mini-cart-actions">
      <FormActions appearance="vertical-full">
        <Link
          disabled={isAmountToReachMinOrderKO}
          buttonAppearance="primary"
          to="/checkout"
        >
          {intl.formatMessage(messages.checkoutAction)}
        </Link>
        <Link buttonAppearance="secondary" to="/cart">
          {intl.formatMessage(messages.cartLink)}
        </Link>
      </FormActions>
    </div>
  );
};

export default MiniCartActions;
